import React, { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { rSetShowFab } from "../../redux/reducers/GlobalVariables";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import Swal from "sweetalert2";
import JobMasterCard from "./JobMasterCard";
import configServ from "../../services/config";
import JobMasterTable from "./JobMasterTable";

const JobMasterPage = () => {
  //#region code
  const { company_id, user_id, is_super, is_admin, permissions } = useSelector(
    (state) => state.GlobalVariables,
  );
  const open = useSelector((state) => state.sideExpand.open);
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [jobCategoryList, setJobCategoryList] = useState([]);
  const [editData, setEditData] = useState({});
  const [jobMasterList, setJobMasterList] = useState([]);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  useEffect(() => {
    //     fetchSalesOrderList();
    scrollToTop();
  }, []);

  const handlePopup = () => {
    if (isCreate === true) {
      clear();
    }
    dispatch(rSetShowFab(isCreate));
    setIsCreate(!isCreate);
    setIsEdit(false);
  };

  const handleEdit = (data) => {
    dispatch(rSetShowFab(isCreate));
    setIsEdit(true);
    setIsCreate(true);
    setEditData(data);
    // console.log("object", data);
  };

  const clear = () => {
    setEditData({});
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will deactivate the job master.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, deactivate it!",
    });

    if (!result.isConfirmed) return;

    try {
      const response = await configServ.deleteJobMaster(id);
      if (response.status) {
        Swal.fire({
          title: "Deactivated!",
          text: "Job master has been deactivated.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
        setIsChanged((p) => !p);
      }
    } catch (e) {
      Swal.fire({ title: "Error!", text: "Something went wrong", icon: "error" });
      console.log(e);
    }
  };

  const fetchActiveJobCategory = async () => {
    try {
      const res = await configServ.getActiveJobCategories({
        company_id: company_id,
      });
      if (res.status) {
        setJobCategoryList(res.data);
      } else {
        setJobCategoryList([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (isCreate) fetchActiveJobCategory();
  }, [isCreate]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);

  const fetchJobMasterList = async () => {
    try {
      setLoader(true);

      const res = await configServ.getJobMasters({
        company_id,
        user_id,
        is_admin: Boolean(is_super || is_admin),
        page: page + 1,
        per_page: rowsPerPage,
      });

      if (res.status) {
        setJobMasterList(res.data); // only data array
        setTotal(res.pagination.total); // total count
      } else {
        setJobMasterList([]);
        setTotal(0);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  // 🔥 IMPORTANT: dependency add karo
  useEffect(() => {
    fetchJobMasterList();
  }, [page, rowsPerPage,isChanged]);

  //#endregion

  return (
    <>
      <Container>
        <CardHeadMenu
          prefix={"Na"}
          suffix={"Na"}
          title={"JOB MASTER"}
          handlePopup={handlePopup}
          isEdit={isEdit}
          create={isCreate}
          showCreate={Boolean(
            is_super || is_admin || permissions?.includes(81),
          )}
        />

        {isCreate && (
          <JobMasterCard
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            editData={editData}
            clear={clear}
            setIsChanged={setIsChanged}
            isChanged={isChanged}
            isCreate={isCreate} // State passed as a prop
            setIsCreate={setIsCreate} // Function passed as a prop
            jobCategoryList={jobCategoryList}
            setEditData={setEditData}
          />
        )}
        <JobMasterTable
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          isChanged={isChanged}
          jobMasterList={jobMasterList}
          loader={loader}
          page={page}
          rowsPerPage={rowsPerPage}
          total={total}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
        />
      </Container>
    </>
  );
};
export default JobMasterPage;
